'use client';

import React from 'react';

import { colors, styled } from 'core/styles';
import { TotalBalanceUSD } from 'domain/types';
import { BgContainer } from 'components';

import { MetricWidget } from './MetricWidget';

export function TotalBalanceWidget({
  balance,
  balanceDayAgo,
}: {
  balance: TotalBalanceUSD;
  balanceDayAgo: TotalBalanceUSD | null | undefined;
}) {
  return (
    <MetricScrollContainer>
      <MetricItemGridContainer>
        <BgContainer>
          <MetricWidget
            title="Total Value Locked"
            amount={balance.totalDeposit}
            prevAmount={balanceDayAgo?.totalDeposit}
            displayGrowthAs="usd"
          />
        </BgContainer>
        <BgContainer>
          <MetricWidget
            title="Total Collateral"
            amount={balance.totalCollateral}
            prevAmount={balanceDayAgo?.totalCollateral}
            displayGrowthAs="usd"
          />
        </BgContainer>
        <BgContainer>
          <MetricWidget
            title="Total Borrows"
            amount={balance.totalDebt}
            prevAmount={balanceDayAgo?.totalDebt}
            displayGrowthAs="usd"
          />
        </BgContainer>
      </MetricItemGridContainer>
    </MetricScrollContainer>
  );
}

const MetricScrollContainer = styled('div')({
  position: 'relative',
  overflow: 'hidden',
  width: 'calc(100% + 16px)',

  '&:after': {
    position: 'absolute',
    top: 0,
    right: 0,
    content: "''",
    width: 20,
    height: '100%',
    background: `linear-gradient(270deg, ${colors.white} 0%, transparent 100%)`,
    flexShrink: 0,
  },
});

const MetricItemGridContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: '1fr',
  gap: 8,
  overflow: 'auto',
  paddingRight: 16,
});
